import { IndividualsDuplexerChannel } from '@wix/ai-scheduling-assistant-common-lib/commonTypes';
import { useDuplexerSubscription } from './use-duplexer-subscription';

const ENTITY_CHANGE_EVENTS: Array<'created' | 'updated' | 'deleted'> = ['created', 'updated', 'deleted'];

/**
 * Fires whenever a v2 AgentTask changes. Payload is entityId-only; callers refetch
 * the task-backed query they render.
 */
export function useAgentTaskDuplexer(onChange: () => void) {
  useDuplexerSubscription(IndividualsDuplexerChannel.AGENT_TASK, () => onChange(), ENTITY_CHANGE_EVENTS);
}
